import type { AppProps } from "next/app";
import Layout from "../components/Layout";
import ErrorBoundary from "../hoc/ErrorBoundary";

import "../../styles/tailwind.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Head from "next/head";

function MyApp({ Component, pageProps }: AppProps) {
  return (
    <>
      <ErrorBoundary>
        <Head>
          <link
            rel="apple-touch-icon"
            sizes="180x180"
            href="/apple-touch-icon.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="32x32"
            href="/favicon-32x32.png"
          />
          <link
            rel="icon"
            type="image/png"
            sizes="16x16"
            href="/favicon-16x16.png"
          />
          <link rel="manifest" href="/site.webmanifest" />
          <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#5c3df5" />
          <meta name="msapplication-TileColor" content="#07070B" />
          <meta name="theme-color" content="#07070B" />
        </Head>
        <Layout>
          <ToastContainer theme="dark" position="bottom-right" />
          <Component {...pageProps} />
        </Layout>
        <div id="modal" />
      </ErrorBoundary>
    </>
  );
}

export default MyApp;
